import { FC, ReactElement } from 'react';

import { AutoCashoutConnected } from '../../components/autoCashout';
import { Bets } from '../../config/bets';

import { CrashAutoPlayConnected } from './CrashAutoPlayConnected';
import { CrashAutoplayModalConnected } from './CrashAutoplayModalConnected';
import { CrashAutoplayModalConnectedV2 } from './autoplayV2/CrashAutoplayModalConnectedV2';
import { UndoControlConnected } from './UndoControlConnected/UndoControlConnected';

import styles from './bettingFooterConnected.module.css';
import { useFeature } from '@pp/core/src/services/features/reactBindings/hooks';

export interface BettingFooterConnectedProps {
  betCode: Bets;
}
export const BettingFooterConnected: FC<BettingFooterConnectedProps> = ({ betCode }): ReactElement => {
  const isAutoplayV2 = useFeature('isAutoplayV2');
  return (
    <div className={styles.betting_footer}>
      <div className={styles.left_control_section}>
        <UndoControlConnected betCode={betCode} />
        <CrashAutoPlayConnected betCode={betCode} />
      </div>
      <AutoCashoutConnected betCode={betCode} />
      <div className={styles.autoPlay_drawer_cell}>
        {isAutoplayV2 ? (
          <CrashAutoplayModalConnectedV2 betId={betCode} />
        ) : (
          <CrashAutoplayModalConnected betId={betCode} />
        )}
      </div>
    </div>
  );
};
